import React from "react";

const Default = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M2 10a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H10a8 8 0 0 1-8-8V10Z"
            fill={fill}
        />
        <path
            d="M24.672 18.592c0 1.236-.27 2.34-.81 3.312a5.82 5.82 0 0 1-2.304 2.268c-.996.552-2.166.828-3.51.828h-5.076V12.256h5.076c1.344 0 2.514.27 3.51.81 1.008.528 1.776 1.272 2.304 2.232.54.96.81 2.058.81 3.294Zm-6.948 3.24c1.044 0 1.866-.282 2.466-.846.6-.564.9-1.362.9-2.394 0-1.02-.3-1.812-.9-2.376-.6-.576-1.422-.864-2.466-.864h-1.206v6.48h1.206Z"
            fill="#fff"
        />
    </svg>
);

export default Default;